const cards = document.querySelectorAll('.card-header');
if (cards) {
	for (let i = 0; i < cards.length; i++) {
		const card = cards[i];
		card.addEventListener('click', (e) => {
			const button = card.querySelector('button');
			button.classList.toggle('collapsed');
			const id = button.dataset.target;
			const collapsed = document.querySelector(id);
			collapsed.classList.toggle('show');
		});
	}
}

if (window.location.href.includes('/ar')) {
	const faqBy = document.getElementsByClassName('accordion_toggle');

	console.log('faqBy: ', faqBy);
	if (faqBy) {
		for (let i = 0; i < faqBy.length; i++) {
			const faqEl = faqBy[i];
			console.log('faqBy: ', faqEl);
			faqEl.checked = false;
            faqEl.classList.add('arbText')
		}
        const container = document.querySelector('#faq');  // отлавливаем все элементы родителя
		if(container) {
			container.addEventListener('click', e => {
            	console.log('5454',e.target)
        	});
		}
        
	}
}
